import { render, staticRenderFns } from "./ImpressosSegurancaRelatorios.vue?vue&type=template&id=27910cbe&"
import script from "./ImpressosSegurancaRelatorios.vue?vue&type=script&lang=js&"
export * from "./ImpressosSegurancaRelatorios.vue?vue&type=script&lang=js&"
import style0 from "./ImpressosSegurancaRelatorios.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports